import {ACTION_CODE} from './_actionCode';
import {ContractorService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_ALL_CONTRACTORS';

export async function getAllContractorInvoices(
    userData: Record<string, string>,
    query = ''
) {
    try {
        LoggerService.logInfo('Action - getAllcontractorInvoices - Start');

        const getAllcontractorInvoicesResult = await ContractorService.getAllContractorInvoices(userData, query);

        const {data, metadata} = getAllcontractorInvoicesResult;

        LoggerService.logInfo('Action - getAllcontractorInvoices - End - Success');

        return ResultModel.newSuccessResult(data, metadata);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllcontractorInvoices - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des factures fournisseurs.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
